import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/services/base.service';
import { FormsService } from 'src/app/services/forms/forms.service';
import { NewFormModel } from 'src/app/services/forms/new-form-model';
import { MessageService } from 'src/app/services/message.service';
import { EditbaseComponent } from '../../editbase.component';
import { SubmenuService } from '../../submenu/submenu.service';

@Component({
  selector: 'app-add-form',
  templateUrl: './add-form.component.html',
  styleUrls: ['./add-form.component.less']
})
export class AddFormComponent extends EditbaseComponent implements OnInit {
 

  page:number = 1;
  componentData: NewFormModel | undefined;
  
  constructor(public formsService: FormsService, public messageService:MessageService, public submenuService:SubmenuService, private router: Router) 
  { 
    super();
    
  }
  
  ngOnInit(): void {

    this.messageService.showLoading();
    this.formsService.loadNewFormModel().subscribe((data:NewFormModel) => {
        this.componentData = data;
        this.messageService.hideLoading();
    },    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }


  save() {
    
    this.messageService.showLoading();
    this.formsService.addNewForm(this.componentData).subscribe((data:any) => {
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");
   
      this.openEditor(data.FormUrl);

    });

  }
  delete() {
    alert('Method not implemented.');
  }
  
  ngAfterViewChecked(){
    this.submenuService.showRecordDetails("/forms", this);    
  }

  openEditor(url){
    var furl =  url; //"/dynamicforms/edit/"+item.FormId+"-"+item.ViewName+"-Edit";
    this.router.navigate(['/editor'], {queryParams:{formurl: furl}});
  }
}
